import styled from "styled-components";

import { Checkbox, Form } from "simplydo/react/ui";

import { FieldProps, getStringFieldOptions } from "./FieldProps";

const StyledForm = styled(Form)`
  margin-left: 15px;
`;

const OptionMultiple = ({
  field,
  fieldValue = [],
  updateIdea,
  isEditing,
}: FieldProps) => {
  const options = getStringFieldOptions(field.options);
  const selectedValues: string[] =
    Array.isArray(fieldValue) ?
      fieldValue.filter((value): value is string => typeof value === "string")
    : [];

  const toggleCheckbox = (option: string) => {
    if (!isEditing) return;
    const isChecked = selectedValues.indexOf(option) > -1;
    if (isChecked)
      updateIdea(
        selectedValues.filter((value) => value !== option),
        ["templated", field.id],
      );
    else updateIdea([...selectedValues, option], ["templated", field.id]);
  };

  return (
    <StyledForm>
      {options
        .filter((option) => isEditing || selectedValues.indexOf(option) > -1)
        .map((option) => (
          <Form.Field key={option}>
            <Checkbox
              label={option}
              checked={selectedValues.indexOf(option) > -1}
              readOnly={!isEditing}
              onChange={() => toggleCheckbox(option)}
            />
          </Form.Field>
        ))}
    </StyledForm>
  );
};

export default OptionMultiple;
